import { render, staticRenderFns } from "./RelatedRecommendation.vue?vue&type=template&id=6fef397c&scoped=true"
import script from "./RelatedRecommendation.vue?vue&type=script&lang=js"
export * from "./RelatedRecommendation.vue?vue&type=script&lang=js"
import style0 from "./RelatedRecommendation.vue?vue&type=style&index=0&id=6fef397c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef397c",
  null
  
)

export default component.exports